import { render, staticRenderFns } from "./AddCallData.vue?vue&type=template&id=2144d77d&scoped=true"
import script from "./AddCallData.vue?vue&type=script&lang=js"
export * from "./AddCallData.vue?vue&type=script&lang=js"
import style0 from "./AddCallData.vue?vue&type=style&index=0&id=2144d77d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2144d77d",
  null
  
)

export default component.exports